import { useEffect } from 'react';
import keycloak from 'auth/keycloak';
import { commonErrorHandling } from 'store/utils';

const determineFrom = (location?: {
  state?: { from?: string };
}): string | null => {
  if (location && location.state && location.state.from) {
    return location.state.from;
  }

  return null;
};

export const RedirectToSignIn = ({
  location
}: {
  location?: { state?: { from?: string } };
}) => {
  const from = determineFrom(location);

  useEffect(() => {
    keycloak
      .createLoginUrl({
        redirectUri: `${window.location.origin}${from || '/'}`
      })
      .then(loginUrl => window.location.replace(loginUrl))
      .catch(error =>
        commonErrorHandling(
          new Error('keycloak failed to build a login url', { cause: error })
        )
      );
  }, [from]);

  return null;
};
